import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BackendResponseI } from '../../../core/services/api/interfaces/backend-response.interface';
import { StorageService } from '../../../core/services/storage/storage.service';
import { SessionService } from '../../../core/services/session/session.service';
import { Role } from '../../../shared/enums/role.enum';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly sessionService: SessionService
  ) {}

  initLoginState(loginResponse: BackendResponseI<string>) {
    const { data } = loginResponse;
    this.storageService.accessToken = data;

    const isAdmin = this.sessionService
      .getDecodedToken()
      .roles.includes(Role.ADMIN);
    const isSuperAdmin = this.sessionService
      .getDecodedToken()
      .roles.includes(Role.SUPER_ADMIN);
    if (isAdmin || isSuperAdmin) this.router.navigate(['graduate-attributes']);
    else this.router.navigate(['/']);
  }
}
